import React, { useEffect, useState } from "react";
import Search from "../Search/Search";
import moreBtnTableIcon from "../../img/moreButtonTable.svg";
import rowDownTable from "../../img/rowDownTableIcon.svg";
import CreateNewDocuments from "../ReusedComponents/CreateNewDocuments/CreateNewDocuments";

const Notifications = (props) => {
  const { getListNotifications } = props;

  const [filter, setFilter] = useState("");
  const [activeCargoCaseTable, setActiveCargoCaseTable] = useState(false);
  const [sortType, setSortType] = useState("down");

  useEffect(() => {
    let isMounted = true;

    if (getListNotifications.length > 0) {
      isMounted && setActiveCargoCaseTable(true);
    } else {
      isMounted && setActiveCargoCaseTable(false);
    }

    return () => {
      isMounted = false;
    };
  }, [getListNotifications.length]);

  const clickSortType = (sortType) => {
    if (sortType === "down") {
      setSortType("up");
      getListNotifications.sort((a, b) => (a.data > b.data ? 1 : -1));
    } else if (sortType === "up") {
      setSortType("down");
      getListNotifications.sort((a, b) => (b.data > a.data ? 1 : -1));
    }
  };

  return (
    <div className="man__container">
      <div className="cargo-case-search-create-button">
        <Search value={filter} setValue={setFilter} />
      </div>
      <div className="cargo-case-main-block">
        {activeCargoCaseTable ? (
          <div className="notificatiot-table-table">
            <div className="notificatiot-table-table-header">
              <p>For user</p>
              <p>Message</p>
              <p onClick={() => clickSortType(sortType)}>
                Dates
                <img
                  className={
                    sortType === "up"
                      ? "notification-table-table-row__row-sort-up"
                      : "notification-table-table-row__row-sort-down"
                  }
                  src={rowDownTable}
                  alt={"icon"}
                />
              </p>
            </div>
            {getListNotifications
              .filter((el) => el?.forUser.includes(filter))
              .map((el, i) => {
                return (
                  <div key={i} className="notificatiot-table-table-row">
                    <p>{el?.forUser}</p>
                    <p>{el?.message}</p>
                    <p>{el?.date}</p>
                    <div>
                      <img src={moreBtnTableIcon} alt={"icon more btn"} />
                    </div>
                  </div>
                );
              })}
          </div>
        ) : (
          <>
            <CreateNewDocuments hiddenButtons={true} />
          </>
        )}
      </div>
    </div>
  );
};
export default Notifications;
